<script lang="ts">
	import { setContext, type Snippet } from 'svelte'
	import { writable, type Writable } from 'svelte/store'
	import type { TabContext } from '$lib/stores/tab-context'

	interface Props {
		vertical?: boolean
		selectedIndex?: number
		class?: string
		onchange?: (index: number, previousIndex: number) => void
		children?: Snippet
	}

	let {
		vertical = false,
		selectedIndex = $bindable(0),
		class: className,
		onchange,
		children,
		...rest
	}: Props = $props()

	const selectedStore: Writable<number> = writable(selectedIndex)

	// Update store when prop changes
	$effect(() => {
		selectedStore.set(selectedIndex)
	})

	setContext<TabContext>('tabs', {
		selected: selectedStore,
		registerPanel: (index: number) => ({
			id: `tab-${index}`,
			selected: selectedStore,
		}),
	})

	// Watch store changes and emit events
	$effect(() => {
		const currentIndex = $selectedStore
		if (currentIndex !== selectedIndex) {
			const previousIndex = selectedIndex
			selectedIndex = currentIndex
			onchange?.(currentIndex, previousIndex)
		}
	})
</script>

<div {...rest} class:flex={vertical} class:flex-col={vertical} class={className}>
	{@render children?.()}
</div>
